export default __webpack_public_path__ + "static/media/second-opinion.6e1fd49a.png";